import Loading from '../../../shared/Loading/Loading';
import AsyncButton from '../../../shared/Loading/AsyncButton';

const CanjeaPuntos = (props) => {
    const interactions = props.interactions || [];
    const prizes = props.prizes || [];
    const getQuantity = (interaction) => Number(props.quantities?.[interaction.id] || 0);
    const totalScore = Number(props.totalScore || 0);
    const premioSeleccionado = props.premioSeleccionado;
    const canContinue = totalScore > 0 && premioSeleccionado && !props.selectionError;

    return (
        <div className="exchange-view max-w-7xl mx-auto px-6 pt-2 pb-2 -mb-8">
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-semibold">Canjea tus puntos</h2>
                <AsyncButton
                    onClick={props.onBack}
                    className="md:hidden px-4 py-2 border border-personalized bg-personalized text-white rounded flex items-center gap-2 hover:bg-white hover:text-personalized"
                >
                    <span>←</span>
                    Volver
                </AsyncButton>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-[1fr_350px] gap-8">
                {/* Columna izquierda: Cards de Pasos 1 y 2 */}
                <div className="space-y-6">
                    {/* Card Paso 1 */}
                    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                            <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-personalized text-sm font-semibold text-white">1</span>
                            Puntos a utilizar
                        </h3>

                        {props.loading && (
                            <div className="flex justify-center rounded-lg border border-gray-200 bg-gray-50 p-6">
                                <Loading size="6" colorBase="white" colorAccent="personalized" double bold="4" />
                            </div>
                        )}

                        {!props.loading && interactions.length === 0 && (
                            <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-500 mb-6">
                                No tienes interacciones disponibles para canjear.
                            </div>
                        )}

                        {!props.loading && interactions.map((interaction) => (
                            <div
                                key={interaction.id}
                                className="mb-3 rounded-lg border border-gray-200 bg-white p-3 shadow-sm"
                            >
                                <div className="grid grid-cols-1 gap-3 sm:grid-cols-[minmax(0,1fr)_9rem] sm:items-center">
                                    <div className="min-w-0">
                                        <p className="font-semibold text-gray-900 break-words">
                                            {interaction.interaction}
                                        </p>
                                        <p className="mt-1 text-sm text-gray-500">
                                            Disponibles: {interaction.itemsToExchange}
                                        </p>
                                        <p className="mt-1 text-sm font-medium text-green-700">
                                            Valor: {interaction.value} puntos
                                        </p>
                                    </div>
                                    <label className="text-sm font-medium text-gray-700">
                                        Cantidad
                                        <div className="exchange-quantity-control mt-1 grid grid-cols-[2rem_minmax(0,1fr)_2rem] overflow-hidden rounded border border-gray-200 bg-white">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    const currentValue = getQuantity(interaction);
                                                    if (currentValue <= 0) return;
                                                    props.onQuantityChange(interaction, currentValue - 1);
                                                }}
                                                disabled={getQuantity(interaction) <= 0}
                                                className="flex h-9 items-center justify-center border-r border-gray-200 text-lg font-semibold text-personalized disabled:text-gray-300"
                                            >
                                                −
                                            </button>
                                            <input
                                                type="text"
                                                value={props.quantities?.[interaction.id] ?? 0}
                                                readOnly
                                                tabIndex={-1}
                                                aria-readonly="true"
                                                className="exchange-quantity-input h-9 w-full cursor-default border-0 px-2 text-center text-sm focus:outline-none"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => props.onQuantityChange(interaction, getQuantity(interaction) + 1)}
                                                disabled={getQuantity(interaction) >= Number(interaction.itemsToExchange || 0)}
                                                className="flex h-9 items-center justify-center border-l border-gray-200 text-lg font-semibold text-personalized disabled:text-gray-300"
                                            >
                                                +
                                            </button>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Card Paso 2 */}
                    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                            <span className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-personalized text-sm font-semibold text-white">2</span>
                            Selecciona un premio
                        </h3>

                        {prizes.map((premio) => (
                            <div key={premio.id} className="mb-2 rounded-lg border border-gray-200 bg-white p-3 shadow-sm transition hover:border-gray-300">
                                {(() => {
                                    const isSelected = premioSeleccionado?.id === premio.id;
                                    const isUnavailable = props.isPrizeUnavailable(premio);
                                    return (
                                        <div className="grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_auto] md:items-start gap-3">
                                            <div className="min-w-0">
                                                <div className="font-semibold break-words">{premio.title}</div>
                                                {premio.description && (
                                                    <div className="text-sm text-gray-500 break-words">{premio.description}</div>
                                                )}
                                                {isUnavailable && (
                                                    <div className="mt-2 text-sm font-semibold text-orange-700">
                                                        {props.redeemedPrizeMessage}
                                                    </div>
                                                )}
                                                {premio.visibleScore && (
                                                    <div className="mt-2 w-fit rounded-md border border-gray-200 bg-green-50 px-3 py-1 text-sm font-semibold text-green-700">
                                                        {premio.prize} puntos
                                                    </div>
                                                )}
                                            </div>
                                            <button
                                                type="button"
                                                disabled={isUnavailable}
                                                onClick={() => props.onPremioSelect(premio)}
                                                className={`w-full md:w-auto px-4 py-2 rounded border text-white ${
                                                    isUnavailable
                                                        ? 'cursor-not-allowed border-gray-200 bg-gray-300'
                                                        : isSelected
                                                            ? 'border-green-600 bg-green-600 hover:bg-white hover:text-green-600'
                                                            : 'border-personalized bg-personalized hover:bg-white hover:text-personalized'
                                                }`}
                                            >
                                                {isSelected ? '✓ Seleccionado' : 'Seleccionar'}
                                            </button>
                                        </div>
                                    );
                                })()}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Columna derecha: Card de Resumen */}
                <div className="exchange-resumen-col">
                    <AsyncButton
                        onClick={props.onBack}
                        className="exchange-back-btn hidden md:flex px-4 py-2 border border-personalized bg-personalized text-white rounded items-center gap-2 hover:bg-white hover:text-personalized"
                    >
                        <span>←</span>
                        Volver
                    </AsyncButton>
                    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                        <h3 className="text-lg font-semibold mb-4 text-gray-900">Resumen de tu canje</h3>

                        <div className="space-y-2 mb-4 pb-4 border-b border-gray-200">
                            <div className="flex justify-between items-center">
                                <p className="text-sm text-gray-700">Tus Puntos disponibles</p>
                                <p className="text-lg font-bold text-personalized">{props.userScore || 0}</p>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="text-sm text-gray-700">Usarás</p>
                                <p className="text-lg font-bold text-gray-900">{totalScore}</p>
                            </div>
                            <div className="flex justify-between items-center">
                                <p className="text-sm text-gray-700">Te quedarán</p>
                                <p className="text-lg font-bold text-gray-900">{Math.max((props.userScore || 0) - totalScore, 0)}</p>
                            </div>
                        </div>

                        <div className="space-y-3 mb-4">
                            {premioSeleccionado && (
                                <div className="rounded bg-blue-50 p-3">
                                    <p className="text-xs text-gray-600 font-medium">Premio seleccionado</p>
                                    <p className="text-sm font-semibold text-gray-900 mt-1 break-words">{premioSeleccionado.title}</p>
                                    {premioSeleccionado.visibleScore && (
                                        <p className="text-xs text-green-700 font-medium mt-2">
                                            Valor: {premioSeleccionado.prize} puntos
                                        </p>
                                    )}
                                </div>
                            )}

                            {props.selectionError && (
                                <div className="rounded border border-orange-200 bg-orange-50 p-3">
                                    <p className="text-sm font-semibold text-orange-700">{props.selectionError}</p>
                                </div>
                            )}

                            {props.leftoverScore > 0 && (
                                <div className="rounded border border-yellow-200 bg-yellow-50 p-3">
                                    <p className="text-sm font-semibold text-yellow-800">
                                        Este canje usará {totalScore} puntos. Los {props.leftoverScore} puntos restantes no se conservan.
                                    </p>
                                </div>
                            )}

                            {!premioSeleccionado && (
                                <div className="rounded bg-gray-50 p-3 text-center">
                                    <p className="text-sm text-gray-500">Selecciona un premio para ver el resumen</p>
                                </div>
                            )}
                        </div>

                        <AsyncButton
                            type="button"
                            onClick={props.onContinuar}
                            disabled={!canContinue}
                            className={`w-full px-4 py-2 rounded border text-white font-medium flex items-center justify-center gap-2 ${
                                canContinue
                                    ? 'border-personalized bg-personalized hover:bg-white hover:text-personalized'
                                    : 'bg-gray-300 cursor-not-allowed border-gray-300'
                            }`}
                        >
                            Continuar
                            <span>→</span>
                        </AsyncButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CanjeaPuntos;
